const digest = '34c9e4fefe0b138186fc2a36d064608636aa7700336a0be8c6e3d28494502dac';
const css = `._answer_ma0sb_1 p{margin:0 0 .5rem}._answer_ma0sb_1 p:last-child{margin-bottom:0}._answer_ma0sb_1 ol,._answer_ma0sb_1 ul{margin:.5rem 0;padding-inline-start:1.5rem}._answer_ma0sb_1 ol:last-child,._answer_ma0sb_1 ul:last-child{margin-bottom:0}._answer_ma0sb_1 ul{list-style:disc}._answer_ma0sb_1 ol{list-style:decimal}._answer_ma0sb_1 li{padding-inline-start:.25rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'answer': '_answer_ma0sb_1' };
export const answer = '_answer_ma0sb_1';
export { css, digest };